module.exports = __webpack_public_path__ + "img/QRcode.a825aaa7.png";